import { render, staticRenderFns } from "./SetupView.vue?vue&type=template&id=6d66ebea&scoped=true"
import script from "./SetupView.vue?vue&type=script&lang=js"
export * from "./SetupView.vue?vue&type=script&lang=js"
import style0 from "./SetupView.vue?vue&type=style&index=0&id=6d66ebea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d66ebea",
  null
  
)

export default component.exports